import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.is-array.js';

function toArray(candidate) {
  if (candidate === undefined || candidate === false) {
    return [];
  }
  return Array.isArray(candidate) ? candidate : [candidate];
}

export { toArray };
